// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Buttons */
.condition-builder-btn {
  background-color: var(--color-icon-muted);
  color: var(--color-white);
  border: none;
  padding: 0.375rem 0.75rem;
  font-size: 0.875rem;
  border-radius: 0.25rem;
}

.add-group-btn {
  background-color: var(--color-primary-green);
  color: var(--color-white);
  border: none;
  padding: 0.375rem 0.75rem;
  font-size: 0.875rem;
  border-radius: 0.25rem;
}

.add-group-btn:hover {
  background-color: var(--color-primary-green);
}

.add-condition-btn {
  background-color: var(--color-primary-green);
  color: var(--color-white);
  border: none;
  padding: 0.375rem 0.75rem;
  font-size: 0.875rem;
  border-radius: 0.25rem;
}

.add-condition-btn:hover {
  background-color: var(--color-primary-green);
}

/* Card Body */
.condition-description {
  font-size: 0.75rem;
  color: var(--color-icon-muted);
}

/* Active Conditions Summary */
.active-conditions-label {
  font-size: 0.8rem;
  font-weight: 600;
}

.group-summary-badge {
  padding: 0.375rem 0.75rem;
  border-radius: 0.25rem;
  font-size: 0.8125rem;
  font-weight: 400;
  background-color: var(--color-white);
}

.and-separator-badge {
  padding: 0.25rem 0.5rem;
  border-radius: 20px;
  font-size: 0.75rem;
  font-weight: 600;
  background-color: #ffc107;
  color: #000;
  border: 2px solid #ffc107;
}

/* Group Colors */
.group-blue {
  border: 1px solid var(--color-link-blue);
  color: var(--color-link-blue);
}

.group-pink {
  border: 1px solid #d63384;
  color: #d63384;
}

.group-green {
  border: 1px solid #198754;
  color: #198754;
}

.group-orange {
  border: 1px solid #fd7e14;
  color: #fd7e14;
}

/* Condition Group Container */
.condition-group-container {
  border-radius: 0.375rem;
  padding: 0.5rem;
  margin-bottom: 1rem;
  background-color: var(--color-white);
}

.condition-group-blue {
  border: 2px solid var(--color-link-blue);
}

.condition-group-pink {
  border: 2px solid #d63384;
}

.condition-group-green {
  border: 2px solid #198754;
}

.condition-group-orange {
  border: 2px solid #fd7e14;
}

/* Group Badge - Made smaller */
.group-badge {
  padding: 0.25rem 0.5rem;
  border-radius: 0.25rem;
  font-size: 0.75rem;
  font-weight: 600;
  color: var(--color-white);
}

.group-badge-blue {
  background-color: var(--color-link-blue);
}

.group-badge-pink {
  background-color: #d63384;
}

.group-badge-green {
  background-color: #198754;
}

.group-badge-orange {
  background-color: #fd7e14;
}

/* Logic Dropdown - Made smaller */
.logic-dropdown {
  width: 70px;
  font-size: 0.75rem;
  padding: 0.25rem 0.5rem;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
}

/* Logic Label - Made smaller */
.logic-label {
  font-size: 0.75rem;
  color: var(--color-icon-muted);
}

/* Condition Number Badge - Made smaller and closer to edge */
/* Condition Number Badge - Made smaller and no extra margins */
.condition-number-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background-color: var(--color-icon-muted);
  color: var(--color-white);
  font-size: 0.7rem;
  font-weight: 600;
  margin: 0;
}

/* Reduce gap in Row for conditions */
.condition-group-container .g-2 {
  --bs-gutter-x: 0.25rem;
}
/* Form Controls */
.condition-select {
  font-size: 0.875rem;
  padding: 0.375rem 0.75rem;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
}

.condition-input {
  font-size: 0.875rem;
  padding: 0.375rem 0.75rem;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
}

/* Delete Button */
.delete-btn {
  background-color: transparent;
  border: none;
  color: var(--color-icon-muted);
  font-size: 1.125rem;
  padding: 0.25rem 0.5rem;
  cursor: pointer;
  transition: color 0.15s ease-in-out;
}

.delete-btn:hover {
  color: #dc3545;
}

.delete-btn i {
  font-size: 1rem;
}

/* AND/OR Separator Dropdown Between Groups */
.group-separator {
  text-align: center;
  margin: 1rem 0;
}

.group-separator-dropdown {
  display: inline-block;
  width: 100px;
  padding: 0.375rem 1.5rem;
  border-radius: 25px;
  font-size: 0.75rem;
  font-weight: 600;
  background-color: var(--color-white);
  color: #000;
  border: 2px solid #ffc107;
  text-align: center;
  cursor: pointer;
}

.group-separator-dropdown:focus {
  border-color: #ffc107;
  box-shadow: 0 0 0 0.2rem rgba(255, 193, 7, 0.25);
}

/* Reduce gap in Row for conditions */
.condition-group-container .g-2 {
  --bs-gutter-x: 0.5rem;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .condition-group-container {
    padding: 0.75rem;
  }
  
  .logic-dropdown {
    width: 65px;
    font-size: 0.7rem;
  }
}

/* Make all checkbox labels match the form-label size */
.form-check-label {
  font-size: 0.87rem !important;
  font-weight: 400 !important;
  color: #212529 !important;
}

/* Keep checkbox label on single line */
.single-line-checkbox label {
  white-space: nowrap !important;
}

.single-line-checkbox .form-check-label {
  white-space: nowrap !important;
}

/* Responsive: Allow wrapping on smaller screens */
@media (max-width: 992px) {
  .single-line-checkbox label {
    white-space: normal !important;
  }
  
  .single-line-checkbox .form-check-label {
    white-space: normal !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/containers/vision_hub/email_rule/components/EmailConditionBuilder.css"],"names":[],"mappings":"AAAA,YAAY;AACZ;EACE,yCAAyC;EACzC,yBAAyB;EACzB,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,4CAA4C;EAC5C,yBAAyB;EACzB,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,4CAA4C;EAC5C,yBAAyB;EACzB,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,4CAA4C;AAC9C;;AAEA,cAAc;AACd;EACE,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA,8BAA8B;AAC9B;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,oBAAoB;EACpB,gBAAgB;EAChB,oCAAoC;AACtC;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,WAAW;EACX,yBAAyB;AAC3B;;AAEA,iBAAiB;AACjB;EACE,wCAAwC;EACxC,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA,8BAA8B;AAC9B;EACE,uBAAuB;EACvB,eAAe;EACf,mBAAmB;EACnB,oCAAoC;AACtC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,+BAA+B;AAC/B;EACE,uBAAuB;EACvB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,kCAAkC;AAClC;EACE,WAAW;EACX,kBAAkB;EAClB,uBAAuB;EACvB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA,+BAA+B;AAC/B;EACE,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA,6DAA6D;AAC7D,+DAA+D;AAC/D;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yCAAyC;EACzC,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;AACX;;AAEA,qCAAqC;AACrC;EACE,sBAAsB;AACxB;AACA,kBAAkB;AAClB;EACE,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA,kBAAkB;AAClB;EACE,6BAA6B;EAC7B,YAAY;EACZ,8BAA8B;EAC9B,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,mCAAmC;AACrC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA,6CAA6C;AAC7C;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,wBAAwB;EACxB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,oCAAoC;EACpC,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,gDAAgD;AAClD;;AAEA,qCAAqC;AACrC;EACE,qBAAqB;AACvB;;AAEA,2BAA2B;AAC3B;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,iBAAiB;EACnB;AACF;;AAEA,uDAAuD;AACvD;EACE,6BAA6B;EAC7B,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA,uCAAuC;AACvC;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA,kDAAkD;AAClD;EACE;IACE,8BAA8B;EAChC;;EAEA;IACE,8BAA8B;EAChC;AACF","sourcesContent":["/* Buttons */\r\n.condition-builder-btn {\r\n  background-color: var(--color-icon-muted);\r\n  color: var(--color-white);\r\n  border: none;\r\n  padding: 0.375rem 0.75rem;\r\n  font-size: 0.875rem;\r\n  border-radius: 0.25rem;\r\n}\r\n\r\n.add-group-btn {\r\n  background-color: var(--color-primary-green);\r\n  color: var(--color-white);\r\n  border: none;\r\n  padding: 0.375rem 0.75rem;\r\n  font-size: 0.875rem;\r\n  border-radius: 0.25rem;\r\n}\r\n\r\n.add-group-btn:hover {\r\n  background-color: var(--color-primary-green);\r\n}\r\n\r\n.add-condition-btn {\r\n  background-color: var(--color-primary-green);\r\n  color: var(--color-white);\r\n  border: none;\r\n  padding: 0.375rem 0.75rem;\r\n  font-size: 0.875rem;\r\n  border-radius: 0.25rem;\r\n}\r\n\r\n.add-condition-btn:hover {\r\n  background-color: var(--color-primary-green);\r\n}\r\n\r\n/* Card Body */\r\n.condition-description {\r\n  font-size: 0.75rem;\r\n  color: var(--color-icon-muted);\r\n}\r\n\r\n/* Active Conditions Summary */\r\n.active-conditions-label {\r\n  font-size: 0.8rem;\r\n  font-weight: 600;\r\n}\r\n\r\n.group-summary-badge {\r\n  padding: 0.375rem 0.75rem;\r\n  border-radius: 0.25rem;\r\n  font-size: 0.8125rem;\r\n  font-weight: 400;\r\n  background-color: var(--color-white);\r\n}\r\n\r\n.and-separator-badge {\r\n  padding: 0.25rem 0.5rem;\r\n  border-radius: 20px;\r\n  font-size: 0.75rem;\r\n  font-weight: 600;\r\n  background-color: #ffc107;\r\n  color: #000;\r\n  border: 2px solid #ffc107;\r\n}\r\n\r\n/* Group Colors */\r\n.group-blue {\r\n  border: 1px solid var(--color-link-blue);\r\n  color: var(--color-link-blue);\r\n}\r\n\r\n.group-pink {\r\n  border: 1px solid #d63384;\r\n  color: #d63384;\r\n}\r\n\r\n.group-green {\r\n  border: 1px solid #198754;\r\n  color: #198754;\r\n}\r\n\r\n.group-orange {\r\n  border: 1px solid #fd7e14;\r\n  color: #fd7e14;\r\n}\r\n\r\n/* Condition Group Container */\r\n.condition-group-container {\r\n  border-radius: 0.375rem;\r\n  padding: 0.5rem;\r\n  margin-bottom: 1rem;\r\n  background-color: var(--color-white);\r\n}\r\n\r\n.condition-group-blue {\r\n  border: 2px solid var(--color-link-blue);\r\n}\r\n\r\n.condition-group-pink {\r\n  border: 2px solid #d63384;\r\n}\r\n\r\n.condition-group-green {\r\n  border: 2px solid #198754;\r\n}\r\n\r\n.condition-group-orange {\r\n  border: 2px solid #fd7e14;\r\n}\r\n\r\n/* Group Badge - Made smaller */\r\n.group-badge {\r\n  padding: 0.25rem 0.5rem;\r\n  border-radius: 0.25rem;\r\n  font-size: 0.75rem;\r\n  font-weight: 600;\r\n  color: var(--color-white);\r\n}\r\n\r\n.group-badge-blue {\r\n  background-color: var(--color-link-blue);\r\n}\r\n\r\n.group-badge-pink {\r\n  background-color: #d63384;\r\n}\r\n\r\n.group-badge-green {\r\n  background-color: #198754;\r\n}\r\n\r\n.group-badge-orange {\r\n  background-color: #fd7e14;\r\n}\r\n\r\n/* Logic Dropdown - Made smaller */\r\n.logic-dropdown {\r\n  width: 70px;\r\n  font-size: 0.75rem;\r\n  padding: 0.25rem 0.5rem;\r\n  border: 1px solid #ced4da;\r\n  border-radius: 0.25rem;\r\n}\r\n\r\n/* Logic Label - Made smaller */\r\n.logic-label {\r\n  font-size: 0.75rem;\r\n  color: var(--color-icon-muted);\r\n}\r\n\r\n/* Condition Number Badge - Made smaller and closer to edge */\r\n/* Condition Number Badge - Made smaller and no extra margins */\r\n.condition-number-badge {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 24px;\r\n  height: 24px;\r\n  border-radius: 50%;\r\n  background-color: var(--color-icon-muted);\r\n  color: var(--color-white);\r\n  font-size: 0.7rem;\r\n  font-weight: 600;\r\n  margin: 0;\r\n}\r\n\r\n/* Reduce gap in Row for conditions */\r\n.condition-group-container .g-2 {\r\n  --bs-gutter-x: 0.25rem;\r\n}\r\n/* Form Controls */\r\n.condition-select {\r\n  font-size: 0.875rem;\r\n  padding: 0.375rem 0.75rem;\r\n  border: 1px solid #ced4da;\r\n  border-radius: 0.25rem;\r\n}\r\n\r\n.condition-input {\r\n  font-size: 0.875rem;\r\n  padding: 0.375rem 0.75rem;\r\n  border: 1px solid #ced4da;\r\n  border-radius: 0.25rem;\r\n}\r\n\r\n/* Delete Button */\r\n.delete-btn {\r\n  background-color: transparent;\r\n  border: none;\r\n  color: var(--color-icon-muted);\r\n  font-size: 1.125rem;\r\n  padding: 0.25rem 0.5rem;\r\n  cursor: pointer;\r\n  transition: color 0.15s ease-in-out;\r\n}\r\n\r\n.delete-btn:hover {\r\n  color: #dc3545;\r\n}\r\n\r\n.delete-btn i {\r\n  font-size: 1rem;\r\n}\r\n\r\n/* AND/OR Separator Dropdown Between Groups */\r\n.group-separator {\r\n  text-align: center;\r\n  margin: 1rem 0;\r\n}\r\n\r\n.group-separator-dropdown {\r\n  display: inline-block;\r\n  width: 100px;\r\n  padding: 0.375rem 1.5rem;\r\n  border-radius: 25px;\r\n  font-size: 0.75rem;\r\n  font-weight: 600;\r\n  background-color: var(--color-white);\r\n  color: #000;\r\n  border: 2px solid #ffc107;\r\n  text-align: center;\r\n  cursor: pointer;\r\n}\r\n\r\n.group-separator-dropdown:focus {\r\n  border-color: #ffc107;\r\n  box-shadow: 0 0 0 0.2rem rgba(255, 193, 7, 0.25);\r\n}\r\n\r\n/* Reduce gap in Row for conditions */\r\n.condition-group-container .g-2 {\r\n  --bs-gutter-x: 0.5rem;\r\n}\r\n\r\n/* Responsive adjustments */\r\n@media (max-width: 768px) {\r\n  .condition-group-container {\r\n    padding: 0.75rem;\r\n  }\r\n  \r\n  .logic-dropdown {\r\n    width: 65px;\r\n    font-size: 0.7rem;\r\n  }\r\n}\r\n\r\n/* Make all checkbox labels match the form-label size */\r\n.form-check-label {\r\n  font-size: 0.87rem !important;\r\n  font-weight: 400 !important;\r\n  color: #212529 !important;\r\n}\r\n\r\n/* Keep checkbox label on single line */\r\n.single-line-checkbox label {\r\n  white-space: nowrap !important;\r\n}\r\n\r\n.single-line-checkbox .form-check-label {\r\n  white-space: nowrap !important;\r\n}\r\n\r\n/* Responsive: Allow wrapping on smaller screens */\r\n@media (max-width: 992px) {\r\n  .single-line-checkbox label {\r\n    white-space: normal !important;\r\n  }\r\n  \r\n  .single-line-checkbox .form-check-label {\r\n    white-space: normal !important;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
